/* 
Object:         chart
Description:    Logic and events for the module chart
Used in:        chart
*/

function makePlotLine(valAxName: string, e: kendo.dataviz.ui.ChartEvent, plotband: PlotBand) {

    if (!valAxName || !e?.sender || !plotband) return;

    const valueAxis = e.sender.getAxis(valAxName);
    if (!valueAxis) return;

    const valueSlot = valueAxis.slot(plotband.from);
    if (!valueSlot) return;

    const categoryAxisConfig = e.sender.options.categoryAxis;

    const categoryAxisName = Array.isArray(categoryAxisConfig)
        ? categoryAxisConfig[0]?.name
        : categoryAxisConfig?.name;

    if (!categoryAxisName) return;

    const categoryAxis = e.sender.getAxis(categoryAxisName);
    if (!categoryAxis) return;

    const lastCategoryIndex = Math.max(1, categoryAxis.range().max);
    const maxCategorySlot = categoryAxis.slot(lastCategoryIndex);
    if (!maxCategorySlot) return;

    const line = new kendo.drawing.Path({
        stroke: {
            color: plotband.color,
            opacity: 1,
            width: 1
        }
    });

    line.moveTo(valueSlot.origin).lineTo([maxCategorySlot.origin.x, valueSlot.origin.y]);

    const group = new kendo.drawing.Group();
    group.append(line);

    e.sender.surface.draw(group);
}



///
/// Render plotbands if near any of the min/max values (samples) or setting min/max chart (design).
///
function printPlotLines(base: kendo.dataviz.ui.ChartValueAxisItem, minChartData: number, maxChartData: number, e: kendo.dataviz.ui.ChartEvent): void {

    if (!base?.plotBands) return;

    const bands = normalizePlotBands(base.plotBands as PlotBands);

    for (const band of bands) {

        // only plotlines (from == to)
        if (band.from === band.to &&
            band.from >= minChartData &&
            band.from <= maxChartData) {

            makePlotLine(base.name, e, band);
        }
    }
}

function normalizePlotBands(plotBands: PlotBands): PlotBand[] {
    return Array.isArray(plotBands) ? plotBands : [plotBands];
}


function axisPlotLines(e: kendo.dataviz.ui.ChartEvent, valaxis: kendo.dataviz.ui.ChartValueAxisItem): void {

    // Get access to the axis (dynamic min and max not in the event (e) variable, use getAxis).
    const chrt = e.sender;

    if (chrt != undefined) {

        const axis = chrt.getAxis(valaxis.name);

        if (axis != undefined) {

            const axisOptions = axis.options as ChartAxisOptions;

            let minChartData: number = axisOptions.min ?? 0; // dynamic min by Kendo
            let maxChartData: number = axisOptions.max ?? 0; // dynamic max by Kendo

            // Check min max (static) values set in design
            const minSetting = valaxis.min;
            const maxSetting = valaxis.max;

            // Check if there is a setup of min/max value
            if (minSetting != undefined) minChartData = minSetting;
            if (maxSetting != undefined) maxChartData = maxSetting;

            printPlotLines(valaxis, minChartData, maxChartData, e);
        }
    }
}

export function onHighLightSampleChart(e: kendo.dataviz.ui.ChartEvent): void { }

export function onSeriesHoverChart(e: kendo.dataviz.ui.ChartEvent): void { }

export function onSeriesOverChart(e: kendo.dataviz.ui.ChartEvent): void { }

export function onSeriesLeaveChart(e: kendo.dataviz.ui.ChartEvent): void { }

//
// Render is called after the chart is drawn. Anything added by the render function is placed on top of the chart.
//
export function onRenderChart(e: kendo.dataviz.ui.ChartEvent): void {

    const valueAxis = e.sender.options.valueAxis;

    if (!valueAxis) return;

    if (Array.isArray(valueAxis)) {
        for (const axis of valueAxis) {
            axisPlotLines(e, axis);
        }
    } else {
        if (valueAxis.plotBands != undefined) {
            axisPlotLines(e, valueAxis);
        }
    }
}

// a and b are javascript Date objects
export function dateDiffInDays(a: Date, b: Date): number {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const inputValidDateTimes = typeof a.getMonth === 'function' && typeof b.getMonth === 'function';

    if (inputValidDateTimes) {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    return 0;
}
